import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as types from '../actions/actionTypes';
import SearchInput from './styles/SearchInput';
import SearchLayout from './styles/Search';
import Icon from './SearchIcon';
import {
    siteSearchFocused, siteSearchBlurred, siteSearchChanged,
} from '../actions/uiActions';

import { getCurrentSearchValue } from '../reducers/ui.sitesearch';
import { getMessage } from '../reducers/i18n';


class SiteSearch extends React.Component {

    state = {
        searchValue: this.props.initialSearchValue,
    };

    // Trigger the search action on key enter.
    onKeyDown = e => {
        if (e.keyCode === 13) {
            this.props.setSearchValue(this.state.searchValue);
            this.props.triggerSearch(this.state.searchValue);
        }
    };

    handleClick = () => {
        this.props.setSearchValue(this.state.searchValue);
        this.props.triggerSearch(this.state.searchValue);
    };

    handleInput = e => {
        this.setState({ searchValue: e.target.value });
    };

    render() {
        return (
            <SearchLayout toolbar onKeyDown={this.onKeyDown}>
                <SearchInput
                    classes={{ input: 'stolo-site-search', root: 'stolo-site-searchroot' }}
                    placeholder={this.props.placeholder}
                    type='search'
                    value={this.state.searchValue}
                    onFocus={this.props.inputActions.siteSearchFocused}
                    onBlur={this.props.inputActions.siteSearchBlurred}
                    onChange={this.handleInput}
                    disableUnderline
                    name='site-search'
                />
                <Icon
                    toolbar={this.props.toolbar}
                    handleClick={this.handleClick}
                />
            </SearchLayout>
        );
    }
}


const mapDispatch = dispatch => ({
    triggerSearch: search => dispatch({
        type: types.NAVIGATED_TO_SEARCHGALLERY,
        meta: { query: { q: search } },
    }),
    setSearchValue: search => dispatch(siteSearchChanged(search)),
    inputActions: bindActionCreators({
        siteSearchBlurred,
        siteSearchFocused,
    }, dispatch),
});

const mapState = state => ({
    initialSearchValue: getCurrentSearchValue(state),
    placeholder: getMessage(state, 'SEARCH_INPUT_PLACEHOLDER'),
});

export default connect(mapState, mapDispatch)(SiteSearch);



// WEBPACK FOOTER //
// ./src/components/SiteSearch.js